import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  HangmanGame,
  ThemeProvider,
  GlobalStyles
} from 'examkrackers-hangman-game'

import { Course } from 'types'
import { isNotNilOrEmpty } from 'utils/ramda'
import { getStudent } from 'modules/auth/ducks/selectors'
import { getCurrentCourse } from 'modules/courses/ducks/selectors'
import AnalyticsService from 'services/AnalyticsService'
import { ANALYTICS_EVENTS } from 'utils/analytics'

export const Hangman = (): JSX.Element => {
  const user = useSelector(getStudent)
  const currentCourse: Course = useSelector(getCurrentCourse)
  const [playHangmanGame, setPlayHangmanGame] = useState(true)

  useEffect(() => {
    if (isNotNilOrEmpty(currentCourse.id) && playHangmanGame) {
      AnalyticsService(user).logEvent(ANALYTICS_EVENTS.playHangmanGame, {
        'Course type': currentCourse?.type || false,
        'Course name': currentCourse?.title || false,
        'Course expiration date': currentCourse?.accessible_to || false,
        'Game name': 'Hangman Game'
      })
      setPlayHangmanGame(false)
    }
  }, [currentCourse, playHangmanGame])

  return (
    <ThemeProvider>
      <>
        <GlobalStyles />
        <HangmanGame />
      </>
    </ThemeProvider>
  )
}

export default Hangman
